import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "px-5",
  style: {"max-height":"900px","overflow-y":"auto"}
}

import { ref, computed, nextTick } from "vue";
import EditNormalEvent from "./edit/EditNormalEvent.vue";
import EditPopupEvent from "./edit/EditPopupEvent.vue";
import EditHeaderEvent from "./edit/EditHeaderEvent.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditEventV2',
  emits: ["submit"],
  setup(__props, { expose: __expose, emit: emits }) {



const modalRef = ref(false);
const eventType = ref<number>(0);
const normalRef = ref<InstanceType<typeof EditNormalEvent>>();
const popupRef = ref<InstanceType<typeof EditPopupEvent>>();
const headerRef = ref<InstanceType<typeof EditHeaderEvent>>();

const isSubmitting = computed(() => {
  if (eventType.value === 0) return normalRef.value?.isSubmitting ?? false;
  if (eventType.value === 1) return popupRef.value?.isSubmitting ?? false;
  return headerRef.value?.isSubmitting ?? false;
});

const show = async (item: any) => {
  eventType.value = item.type ?? 0;
  modalRef.value = true;
  await nextTick();
  if (eventType.value === 0) normalRef.value?.load(item);
  else if (eventType.value === 1) popupRef.value?.load(item);
  else headerRef.value?.load(item);
};

const hide = () => {
  modalRef.value = false;
};

const triggerSubmit = () => {
  if (eventType.value === 0) normalRef.value?.submit();
  else if (eventType.value === 1) popupRef.value?.submit();
  else headerRef.value?.submit();
};

const onChildSubmit = () => {
  emits("submit");
};

__expose({ show });

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: modalRef.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modalRef).value = $event)),
    title: _ctx.$t('action.editEvent'),
    "before-close": hide,
    class: "w-1000px",
    "align-center": ""
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        onClick: hide,
        disabled: isSubmitting.value
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("action.cancel")), 1)
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: triggerSubmit,
        loading: isSubmitting.value
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("action.confirm")), 1)
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (eventType.value === 0)
          ? (_openBlock(), _createBlock(EditNormalEvent, {
              key: 0,
              ref_key: "normalRef",
              ref: normalRef,
              onSubmit: onChildSubmit
            }, null, 512))
          : _createCommentVNode("", true),
        (eventType.value === 1)
          ? (_openBlock(), _createBlock(EditPopupEvent, {
              key: 1,
              ref_key: "popupRef",
              ref: popupRef,
              onSubmit: onChildSubmit
            }, null, 512))
          : _createCommentVNode("", true),
        (eventType.value === 2)
          ? (_openBlock(), _createBlock(EditHeaderEvent, {
              key: 2,
              ref_key: "headerRef",
              ref: headerRef,
              onSubmit: onChildSubmit
            }, null, 512))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})